import PropTypes from "prop-types";
import React from "react";
import Popovers from "../Popovers/Popovers";
import helpers from "../../helpers";
import ShowAllModal from "../../components/ShowAllModal";
import reactT from '../../components/reactT';

class FederatedListFacet extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filter: "",
      truncateFacetListsAt: 7,
      textFilter: "",
    };
  }

  handleClick(value) {
    const { foundIdx, parsed, isQsParamField, param } =
      helpers.qs.getFieldQsInfo({
        field: this.props.field,
        values: this.props.value,
        value,
      });

    // Define var for new parsed qs params object.
    let newParsed = parsed;

    // If the clicked list facet field is one whose state is tracked in the qs.
    if (isQsParamField) {
      // If the click is adding the field value.
      if (foundIdx < 0) {
        // If there is already a qs param for this field value.
        if (param) {
          // Add value to parsed qs params.
          newParsed = helpers.qs.addValueToQsParam({
            field: this.props.field,
            value,
            param,
            parsed,
          });
        } else {
          // If there is not already a qs param for this field value.
          // Add new qs param for field + value.
          newParsed = helpers.qs.addQsParam({
            field: this.props.field,
            value,
            parsed,
          });
        }

        // Send new query based on app state.
        this.props.onChange(this.props.field, this.props.value.concat(value));
      } else {
        // If the click is removing this field value.
        // If their is already a qs param for this field value.
        if (param) {
          newParsed = helpers.qs.removeValueFromQsParam({
            field: this.props.field,
            value,
            param,
            parsed,
          });
        }

        // Send new query based on app state.
        this.props.onChange(
          this.props.field,
          this.props.value.filter((v, i) => i !== foundIdx)
        );
      }

      helpers.qs.addNewUrlToBrowserHistory(newParsed);
    }
  }

  getHighlightedText(text, highlight) {
    // Split on highlight term and include term into parts, ignore case
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
    return <span> { parts.map((part, i) => 
        <span key={i} className={part.toLowerCase() === highlight.toLowerCase() ? 'font-weight-bold' : '' }>
            { part }
        </span>)
    } </span>;
  }


  removeAllListFacetValues (e, searchFieldName, searchFieldValues) {
    e.preventDefault();
    const values = searchFieldValues;
    const field = searchFieldName;
    for (const value of values) {
      const { foundIdx, parsed, isQsParamField, param } =
        helpers.qs.getFieldQsInfo({
          field,
          values,
          value,
        });

      // Confirm the field value is set in state.
      if (foundIdx > -1) {
        // If the field is one whose state is tracked in qs and there is currently a param for it.
        if (isQsParamField && param) {
          const newParsed = helpers.qs.removeValueFromQsParam({
            field,
            value,
            param,
            parsed,
          });

          helpers.qs.addNewUrlToBrowserHistory(newParsed);
        }
      }
    }

    // Send query based on new state.
    this.props.onChange(field, []);
  }

  render() {
    const { label, facets, field, value, options , collapse, id, CurrentFacetsCounter, customComponents, onSearchFieldChange, showAllTitle} =
      this.props;
    const CurrentQueryComponent = customComponents.searchFields.currentQuery;
    const { truncateFacetListsAt } = this.state;
    const siteList = options.siteList;
    const facetCounts = facets.filter((facet, i) => i % 2 === 1);
    const facetValues = facets.filter((facet, i) => i % 2 === 0);
    // Create an object of facets {value: count} to keep consistent for inputs.
    const facetInputs = {};
    // Facets fields
    const fields = [
      "sm_site_name",
      "ds_created",
      "ss_type",
      "sm_region_name",
      "sm_country_name",
      "ss_document_type_name",
      "sm_keywords_name",
    ];

    const langcode = document.querySelector('html').getAttribute('lang');
    // Handle site name restrictions.
    if (field === "sm_site_name" && siteList.length > 0) {
      facetValues.forEach((v, i) => {
        const key = facetValues[i];
        if (siteList.indexOf(v) > -1) {
          facetInputs[key] = facetCounts[i];
        }
      });
      // If only one option exists and nothing is selected, don't show it.
      if (value.length < 1 && Object.keys(facetInputs).length < 2) {
        return null;
      }
    } else if (fields.includes(field)) {
      let total = 0;
      facetCounts.forEach((v) => {
        total += v;
      });

      if (total < 1) {
        return null;
      } else {
        facetValues.forEach((v, i) => {
          const key = facetValues[i];
          facetInputs[key] = facetCounts[i];
        });
      }
    } else {
      facetValues.forEach((v, i) => {
        const key = facetValues[i];
        facetInputs[key] = facetCounts[i];
      });
    }

    let vocabularyDescription ='';
    if(typeof drupalSettings !== 'undefined' && id !== undefined) {
      /*global drupalSettings:true*/
      if (drupalSettings.facets_vocabularies[id] !== undefined) {
        if(drupalSettings.facets_vocabularies[id].vocabulary_description !== '' && drupalSettings.facets_vocabularies[id].vocabulary_description !== null){
          vocabularyDescription = drupalSettings.facets_vocabularies[id].vocabulary_description;
        }
      }
    }

    const expanded = !collapse;

    const facetValuesCount = facetValues.filter(
      (facetValue, i) =>
        facetInputs[facetValue] > 0
      ).length;

      const russianPattern = /^[аАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯ0-9]+$/ug;
      const spanishPattern =  /[A-Za-záÁéÉíÍóÓúÚñÑüÜ0-9]/;
      const englishPattern =  /[A-Za-z0-9]/;

      const groupNames = arr => {
         const map = arr.reduce((acc, val) => {
            let char = val.charAt(0).toUpperCase();

            let charHandledByLang = '';
            if (langcode === 'ru') {
              charHandledByLang = char.match(russianPattern) ? char : '#';
            }
            else if (langcode === 'es') {
              charHandledByLang = char.match(spanishPattern) ? char : '#';
            }
            else if (langcode === 'en') {
              charHandledByLang = char.match(englishPattern) ? char : '#';
            }
            acc[charHandledByLang] = [].concat((acc[charHandledByLang] || []), val);

            return acc;
         }, {});

         let mapObjectKeys = Object.keys(map) ;
         if (mapObjectKeys[0] === '#') {
          let hash = mapObjectKeys[0];
          delete mapObjectKeys[0];
          mapObjectKeys[mapObjectKeys.length] = hash;
         }

         const res =  mapObjectKeys.map(el => ({
            letter: el,
            names: map[el]
         }));
         return res;
      };

    var collator = new Intl.Collator(langcode);

    const facetValuesGroupedByFirstChar = groupNames(facetValues.filter(
      (facetValue, i) =>
        facetInputs[facetValue] > 0))
      .sort(function(a, b) {
        return collator.compare(a.letter, b.letter)
      });

     // This is not a hierarchy of accordion groups,
    // just render the single list-facet accordion.
    return (
      <div className={`block block-unhcr-search block-${field}`}>
        <div className="accordion-filter pb-0" id={`accordion-${field}`}>
          <div className="card-facet">
            <div
              className="card-header-facet d-flex align-items-center justify-content-between"
              id={label.replace(/\s+/g, "-").toLowerCase()}
            >
              <div className="section-accordion-title d-flex justify-content-between align-items-center">
                <div className="d-inline-block">
                  <span>{label}</span>
                  <Popovers text={vocabularyDescription} />
                </div>
              </div>
              <span
                className={expanded ? 'section-accordion-toggle' : 'section-accordion-toggle collapsed'}
                role="button"
                data-toggle="collapse"
                data-target={`#collapse-${field}`}
                aria-expanded={expanded ? "true" : "false"}
                aria-controls={`collapse-${field}`}
                aria-label="Toggle collapse"
              />
            </div>
            <div
              id={`collapse-${field}`}
              className={expanded ? 'collapse show pb-2' : 'collapse pb-2'}
            >
              <div
                className="card-body-facet"
                key={`solr-list-facet-${field}-ul`}
              >
               <ul className="list-unstyled pl-0">
                {facetValues
                .sort(function (a, b) {return a.toLowerCase().localeCompare(b.toLowerCase());})
                  .filter(
                    (facetValue, i) =>
                      facetInputs[facetValue] > 0
                  )
                  .filter(
                    (facetValue, i) =>
                    i < truncateFacetListsAt
                  )
                  .map((facetValue, i) => {
                    if (
                      this.state.filter.length === 0 ||
                      facetValue
                        .toLowerCase()
                        .indexOf(this.state.filter.toLowerCase()) > -1
                    ) {
                      let label = facetValue;

                      if (
                        field === "ss_type" &&
                        typeof drupalSettings !== "undefined"
                      ) {
                        label =
                          drupalSettings.content_types_labels[facetValue].label;
                      }

                      let termDescription ='';
                      if(typeof drupalSettings !== 'undefined' && id !== undefined && facetValue !== undefined) {
                        if(drupalSettings.facets_vocabularies[id] !== undefined) {
                          if(drupalSettings.facets_vocabularies[id].terms !== '' && drupalSettings.facets_vocabularies[id].terms !== null) {
                            if (drupalSettings.facets_vocabularies[id].terms[facetValue] !== null && drupalSettings.facets_vocabularies[id].terms[facetValue] !== undefined) {
                              termDescription = drupalSettings.facets_vocabularies[id].terms[facetValue].term_description;
                            }
                          }
                        }
                      }

                      return (
                        <li key={`${facetValue}_${facetInputs[facetValue]}`} className="d-flex align-items-baseline search-accordion__checkbox-label">
                            <input
                              type="checkbox"
                              name={field}
                              id={field+'_'+facetValue.replace(/\s+/g, '_').toLowerCase()}
                              value={facetValue}
                              checked={value.indexOf(facetValue) > -1}
                              onChange={() => this.handleClick(facetValue)}
                            />
                          <label className="d-flex align-items-baseline mb-0 ml-2" htmlFor={field+'_'+facetValue.replace(/\s+/g, '_').toLowerCase()}>
                            <span className="checkbox-label-text">
                              {label}
                              <span className="facet-item-amount">
                                {" "}
                                (
                                {facetInputs[facetValue] > 0
                                  ? facetInputs[facetValue]
                                  : "+"}
                                )
                                {" "}
                              </span>
                            </span>
                          </label>
                          <Popovers text={termDescription} />
                        </li>
                      );
                    }
                    return null;
                  })}
                  </ul>
                  {facetValuesCount > truncateFacetListsAt ? 
                  <ShowAllModal 
                  title={label}
                  triggerLabel={reactT("Show all")+' '+showAllTitle.toLowerCase()}
                  filter={
                    <div className="unhcr-search w-100 mt-3">
                    <div className="view-filters mb-0">
                      <form className="views-exposed-form">
                        <div className="form-row">
                            <div className="form-item-keywords">
                            <input
                              type="text"
                              className="form-control bg-white"
                              name="filter"
                              id="facetsTextFilter"
                              value={this.state.textFilter} 
                              onChange={event => this.setState({
                                textFilter: event.target.value,
                              })}
                              placeholder={reactT('Search')}
                            />
                            </div>
                        </div>
                      </form>
                    </div>
                  </div>
                          }
                clearFilter={() => this.setState({
                  textFilter: '',
                })}
                currentQuery={
                  <CurrentQueryComponent
                    {...this.props}
                    onChange={onSearchFieldChange}
                    currentQueryType={'list-facet'}
                    currentQueryField={field}
                    onClear={(e) =>
                      this.removeAllListFacetValues(e, field, value)
                    }
                    />
                  }
                  selectedCount={value.length}
                  onClear={(e) =>
                    this.removeAllListFacetValues(e, field, value)
                  }
                  CurrentFacetsCounter={CurrentFacetsCounter}
                >

                  {facetValuesGroupedByFirstChar
                  .map((facetValue, i) => {
                    const filteredFacetValueName =facetValue.names
                      .filter((name) =>
                      !this.state.textFilter || name.toLowerCase().includes(this.state.textFilter.toLowerCase()));

                    if (filteredFacetValueName.length >0) {
                      return (
                        <div className="facet-modal-group" key={'facet-modal-group-'+i}>
                        <h5>{facetValue.letter}</h5>
                        <ul className="list-unstyled pl-0">
                        {filteredFacetValueName
                        .sort(function (a, b) {return a.toLowerCase().localeCompare(b.toLowerCase());})
                        .map(
                          (facetValueName, i) => {
                            if (
                              this.state.filter.length === 0 ||
                              facetValueName
                                .toLowerCase()
                                .indexOf(this.state.filter.toLowerCase()) > -1
                            ) {
                              let label = facetValueName;
                            
                              if (
                                field === "ss_type" &&
                                typeof drupalSettings !== "undefined"
                              ) {
                                label =
                                  drupalSettings.content_types_labels[facetValueName].label;
                              }
                            
                              let termDescription ='';
                              if(typeof drupalSettings !== 'undefined' && id !== undefined && facetValueName !== undefined) {
                                if(drupalSettings.facets_vocabularies[id] !== undefined) {
                                  if(drupalSettings.facets_vocabularies[id].terms !== '' && drupalSettings.facets_vocabularies[id].terms !== null) {
                                    if (drupalSettings.facets_vocabularies[id].terms[facetValueName] !== null && drupalSettings.facets_vocabularies[id].terms[facetValueName] !== undefined) {
                                      termDescription = drupalSettings.facets_vocabularies[id].terms[facetValueName].term_description;
                                    }
                                  }
                                }
                              }
                            
                              return (
                                <li key={`${facetValueName}_${facetInputs[facetValueName]}`} className="d-flex align-items-baseline search-accordion__checkbox-label">
                                    <input
                                      type="checkbox"
                                      name={field}
                                      id={field+'_'+facetValueName.replace(/\s+/g, '_').toLowerCase()}
                                      value={facetValueName}
                                      checked={value.indexOf(facetValueName) > -1}
                                      onChange={() => this.handleClick(facetValueName)}
                                    />
                                  <label className="d-flex align-items-baseline mb-0 ml-2" htmlFor={field+'_'+facetValueName.replace(/\s+/g, '_').toLowerCase()}>
                                    <span className="checkbox-label-text">
                                      {this.getHighlightedText(label,this.state.textFilter)}
                                      <span className="facet-item-amount">
                                        {" "}
                                        (
                                        {facetInputs[facetValueName] > 0
                                          ? facetInputs[facetValueName]
                                          : "+"}
                                        )
                                        {" "}
                                      </span>
                                    </span>
                                  </label>
                                  <Popovers text={termDescription} />
                                </li>
                              );
                            }
                            return null;
                          }
                        )
                       }
                       </ul>
                       </div>)
                    }
                    return null;
}
                  )}
                    </ShowAllModal> : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FederatedListFacet.defaultProps = {
  hierarchy: false,
  expandedHierarchies: [],
  value: [],
};

FederatedListFacet.propTypes = {
  bootstrapCss: PropTypes.bool,
  children: PropTypes.array,
  collapse: PropTypes.bool,
  expandedHierarchies: PropTypes.array,
  facetSort: PropTypes.string,
  facets: PropTypes.array.isRequired,
  field: PropTypes.string.isRequired,
  hierarchy: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onFacetSortChange: PropTypes.func,
  onSetCollapse: PropTypes.func,
  query: PropTypes.object,
  truncateFacetListsAt: PropTypes.number,
  value: PropTypes.array,
};

export default FederatedListFacet;
